import { render, staticRenderFns } from "./NewChildAppointments.vue?vue&type=template&id=030f9abe&scoped=true&"
import script from "./NewChildAppointments.vue?vue&type=script&lang=js&"
export * from "./NewChildAppointments.vue?vue&type=script&lang=js&"
import style0 from "./NewChildAppointments.vue?vue&type=style&index=0&id=030f9abe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f9abe",
  null
  
)

export default component.exports